import { memo, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { formatNumberWithCommas } from "Utilities/Number/formatNumberWithCommas";

const NUMBERS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5,
  6, 7, 8, 9,
];

// lib
const AnimatedNumbers = ({ number, onAnimationComplete }) => {
  const [height, setHeight] = useState(null);

  const measuringRef = useRef();

  const keyCount = useRef(0);
  const animateToNumbersArr = Array.from(
    "$" + formatNumberWithCommas(number)
  ).map((n) => (isNaN(n) ? n : n * 1));

  const onRest = () => onAnimationComplete && onAnimationComplete();

  useEffect(() => {
    setHeight(measuringRef.current?.getBoundingClientRect().height);
  }, []);

  return (
    <Wrapper>
      {height === null || height === undefined ? (
        <Measuring ref={measuringRef}>
          {formatNumberWithCommas(number)}
        </Measuring>
      ) : (
        <>
          {animateToNumbersArr.map((n, index) => {
            if (typeof n === "string") {
              return <div key={index}>{n}</div>;
            }

            return (
              <div
                key={index}
                data-cy="animated-number"
                style={{
                  height: height,
                  overflow: "hidden",
                  display: "flex",
                }}
              >
                <motion.div
                  key={`${keyCount.current++}`}
                  data-cy="animated-number-inner"
                  layout
                  initial={{
                    translateY: 0,
                  }}
                  animate={{
                    translateY: [
                      0,
                      -1 * (height * animateToNumbersArr[index]) - height * 19,
                      -1 * (height * animateToNumbersArr[index]) - height * 20,
                    ],
                  }}
                  transition={{
                    times: [0, 0.65, 1],
                    duration: 0.75,
                    ease: "easeOut",
                  }}
                  onAnimationComplete={onRest}
                >
                  {NUMBERS.map((num, i) => (
                    <div key={i}>{num}</div>
                  ))}
                </motion.div>
              </div>
            );
          })}
        </>
      )}
    </Wrapper>
  );
};

const Enhanced = memo(AnimatedNumbers);

export default Enhanced;

const Wrapper = styled.div`
  display: flex;
`;
const Measuring = styled.div`
  position: absolute;
  opacity: 0;
`;
